export default __webpack_public_path__ + "static/media/sub-category-fitness-danceStudio.15846b89.jpg";